import { render, staticRenderFns } from "./PlayerBehaviourDetails.vue?vue&type=template&id=0dc49e71&scoped=true"
import script from "./PlayerBehaviourDetails.vue?vue&type=script&lang=js"
export * from "./PlayerBehaviourDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc49e71",
  null
  
)

export default component.exports